import getters from '@/store/modules/agenda/getters'
import mutations from '@/store/modules/agenda/mutations'
import actions from '@/store/modules/agenda/actions'

export default {
  namespaced: true,
  state() {
    return {
      eventsList: [],
      eventsListUnplanned: [],
      event: {},
      eventMetadata: {},
      planningMetadata: [],
      eventDisponibilities: [],
      calendarState: null,
    }
  },
  getters,
  actions,
  mutations
}
